export default __webpack_public_path__ + "static/media/cv151-3.e15ac66d.png";